import { render, staticRenderFns } from "./AddLanguage.vue?vue&type=template&id=9a4452fe&scoped=true"
import script from "./AddLanguage.vue?vue&type=script&lang=js"
export * from "./AddLanguage.vue?vue&type=script&lang=js"
import style0 from "./AddLanguage.vue?vue&type=style&index=0&id=9a4452fe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4452fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a4452fe')) {
      api.createRecord('9a4452fe', component.options)
    } else {
      api.reload('9a4452fe', component.options)
    }
    module.hot.accept("./AddLanguage.vue?vue&type=template&id=9a4452fe&scoped=true", function () {
      api.rerender('9a4452fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/DemandForm/AddLanguage.vue"
export default component.exports